import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22211e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-white p-4 flex flex-col gap-4" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "プライバシーポリシー（個人情報保護方針）"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-full font-sans text-base md:text-lg" }, [
    /*#__PURE__*/_createTextVNode(" ムロ製作所（以下、「当社」という。）は，ユーザーの個人情報について以下のとおりプライバシーポリシー（以下、「本ポリシー」という。）を定めます。本ポリシーは、当社がどのような個人情報を取得し、どのように利用・共有するか、ユーザーがどのようにご自身の個人情報を管理できるかをご説明するものです。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【事業者情報】"),
    /*#__PURE__*/_createElementVNode("p", null, "販売事業者名：ムロ製作所"),
    /*#__PURE__*/_createElementVNode("p", null, "住所：〒259-1217 神奈川県平塚市長持359"),
    /*#__PURE__*/_createElementVNode("p", null, "代表者：室谷 英明"),
    /*#__PURE__*/_createElementVNode("h1", null, "【個人情報の取得方法】"),
    /*#__PURE__*/_createTextVNode(" 当社はユーザーが利用登録をするときメールアドレスを取得させていただきます。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【個人情報の利用目的】"),
    /*#__PURE__*/_createTextVNode(" ユーザー別に設定情報や利用履歴を管理するために利用します。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【個人データを安全に管理するための措置】"),
    /*#__PURE__*/_createTextVNode(" 当社は個人情報を不正なアクセス・改ざん・漏えい・滅失及び毀損から保護するため全従業員及び役員に対して教育研修を実施しております。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【個人データの第三者提供について】"),
    /*#__PURE__*/_createTextVNode(" 当社は法令及びガイドラインに別段の定めがある場合を除き、同意を得ないで第三者に個人情報を提供することは致しません。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【保有個人データの開示、訂正】"),
    /*#__PURE__*/_createTextVNode(" 当社は本人から個人情報の開示を求められたときには、遅滞なく本人に対しこれを開示します。個人情報の利用目的の通知や訂正、追加、削除、利用の停止を希望される方は以下の手順でご請求ください。 お問い合わせ窓口 fu360muro@gmail.com "),
    /*#__PURE__*/_createElementVNode("h1", null, "【個人情報取り扱いに関する相談や苦情の連絡先】"),
    /*#__PURE__*/_createTextVNode(" 当社の個人情報の取り扱いに関するご質問やご不明点、苦情、その他のお問い合わせはfu360muro@gmail.comよりご連絡ください。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【SSL（Secure Socket Layer）について】"),
    /*#__PURE__*/_createTextVNode(" 当社のWebサイトはSSLに対応しており、WebブラウザとWebサーバーとの通信を暗号化しています。ユーザーが入力する個人情報は自動的に暗号化されます。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【cookieについて】"),
    /*#__PURE__*/_createTextVNode(" cookieとは、WebサーバーからWebブラウザに送信されるデータのことです。Webサーバーがcookieを参照することでユーザーのパソコンを識別でき、効率的に当社Webサイトを利用することができます。当社Webサイトがcookieとして送るファイルは、個人を特定するような情報は含んでおりません。 お使いのWebブラウザの設定により、cookieを無効にすることも可能です。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【プライバシーポリシーの制定日及び改定日】"),
    /*#__PURE__*/_createElementVNode("p", null, "制定：2023年4月13日"),
    /*#__PURE__*/_createElementVNode("h1", null, "【免責事項】"),
    /*#__PURE__*/_createTextVNode(" 当社Webサイトに掲載されている情報の正確性には万全を期していますが、利用者が当社Webサイトの情報を用いて行う一切の行為に関して、一切の責任を負わないものとします。 当社は、利用者が当社Webサイトを利用したことにより生じた利用者の損害及び利用者が第三者に与えた損害に関して、一切の責任を負わないものとします。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【著作権・肖像権】"),
    /*#__PURE__*/_createTextVNode(" 当社Webサイト内の文章や画像、すべてのコンテンツは著作権・肖像権等により保護されています。無断での使用や転用は禁止されています。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【リンク】"),
    /*#__PURE__*/_createTextVNode(" 当社Webサイトへのリンクは、自由に設置していただいて構いません。ただし、Webサイトの内容等によってはリンクの設置をお断りすることがあります。 ")
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "特定商取引法に基づく表記"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-full font-sans" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "【アプリ名】"),
    /*#__PURE__*/_createTextVNode(" 株探拡張pro "),
    /*#__PURE__*/_createElementVNode("h1", null, "【お問い合わせ】"),
    /*#__PURE__*/_createTextVNode(" munroyello@gmail.comからお問い合わせください。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【販売価格】"),
    /*#__PURE__*/_createTextVNode(" 購入手続きの際に画面に表示されます。 消費税は内税として表示しております。 販売価格以外でお客様に発生する金銭 当サイトのページの閲覧、コンテンツ購入、ソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金は、お客様のご負担となります。 お支払方法 下のいずれかのお支払方法をご利用いただけます。 "),
    /*#__PURE__*/_createElementVNode("p", null, "・各種クレジットカード"),
    /*#__PURE__*/_createElementVNode("p", null, "・その他、購入にかかる決済を代行する会社が提供する支払方法 商品購入方法"),
    /*#__PURE__*/_createTextVNode(" 商品ページからGooleアカウントでログイン後、「無料トライアルを始める」ボタンを押下し、 各種お支払方法で決済していただきますと、VIPプランが適用されます。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【商品解約方法】"),
    /*#__PURE__*/_createTextVNode(" 商品ページからGooleアカウントでログイン後、「支払い情報の確認」ボタンを押下し、 「プランをキャンセル」をクリックしていただきますと解約され無料プランに戻ります。 デジタルアイテム等の利用が可能となる時期 特別な定めを置いている場合を除き、お支払い手続き完了後から解約するまでご利用いただけます。 "),
    /*#__PURE__*/_createElementVNode("h1", null, "【動作環境】"),
    /*#__PURE__*/_createTextVNode(" 株探拡張proはChrome拡張です。Chromeが正常に動作するPC端末であればOSに関係なく動作します。 (*スマートフォンは非対応です) ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_view = _resolveComponent("header-view")!
  const _component_section_row = _resolveComponent("section-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_header_view, { isLp: _ctx.isLp }, null, 8, ["isLp"])
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })
  ], 64))
}